interface ThirdPartyToggleProps {
  checked: boolean;
  onToggle: () => void;
}

/**
 * Switch between the in-house and agency versions of the comparison copy.
 * @param props - current agency mode and the toggle handler
 * @returns the switch
 */
export default function ThirdPartyToggle({ checked, onToggle }: ThirdPartyToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={onToggle}
      className="inline-flex min-h-[36px] items-center gap-2.5 rounded-full border border-landing-primary bg-white py-1.5 pl-1.5 pr-3.5 text-tag-sm text-landing-secondary transition-colors hover:text-landing-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--landing-cta-light)"
    >
      <span
        className={`relative h-5 w-9 rounded-full transition-colors duration-200 ${
          checked ? "bg-(--landing-cta-light)" : "bg-gray-200"
        }`}
      >
        <span
          className={`absolute left-0.5 top-0.5 size-4 rounded-full bg-white shadow-sm transition-transform duration-200 ${
            checked ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </span>
      I&apos;m an agency
    </button>
  );
}
